var _path, _path2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwimSenseSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SwimSense_Small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.13,187.78V38.91A28.91,28.91,0,0,1,74,10h0A28.88,28.88,0,0,1,103,38.91V62.33",
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.76,190V38.91C125.76,26.62,138.7,10,154.67,10h0a28.91,28.91,0,0,1,28.91,28.91V62.33",
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 46.47,
    y1: 87.95,
    x2: 124,
    y2: 87.96,
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45.79,
    y1: 127.39,
    x2: 123.32,
    y2: 127.41,
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 46.47,
    y1: 166.83,
    x2: 124,
    y2: 166.85,
    fill: "none",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimSenseSmall);
export default __webpack_public_path__ + "static/media/SwimSense_Small.28be04c0e0925c836a4ea6c0f9cac0b7.svg";
export { ForwardRef as ReactComponent };